function waitForElement(selector) {
  return new Promise(resolve => {
    // If the element already exists
    const element = document.querySelector(selector);
    if (element) {
      resolve(element);
      return;
    }

    // If the element doesn't exist, set up the observer
    const observer = new MutationObserver(mutations => {
      const element = document.querySelector(selector);
      if (element) {
        observer.disconnect();
        resolve(element);
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  });
}

// Usage
waitForElement('.stamped-rewards-widget-btn-sign-in')
  .then(stampedLoginBtn => {
    stampedLoginBtn.onclick = function() {
      window.location.href = '/customer_authentication/login?return_to=' + encodeURIComponent(window.location.pathname);
    };
  });